import { useEffect } from 'react';
import { getCurrentUser } from '../services/userService';
import { useAuthStore } from '../store/authStore';

export default function useAuthInit(): void {
    const initialized = useAuthStore((s) => s.initialized);
    const user = useAuthStore((s) => s.user); // ✅ ADD THIS
    const setUser = useAuthStore((s) => s.setUser);
    const clearUser = useAuthStore((s) => s.clearUser);
    const setInitialized = useAuthStore((s) => s.setInitialized);

    useEffect(() => {
        if (initialized) return;

        let cancelled = false;

        const init = async () => {
            try {
                // If user already exists (from login), don't call API
                if (user && user.id) {
                    setInitialized(true);
                    return;
                }

                const token = localStorage.getItem('token');

                // ❗ STOP HERE if no token
                if (!token) {
                    clearUser();
                    setInitialized(true);
                    localStorage.removeItem('token');
                    return;
                }
                // Always try the API once so tenant subdomains can reuse the
                // Laravel web session created by /switch-tenant/{token}.
                const currentUser = await getCurrentUser();

                if (!cancelled) {
                    setUser(currentUser);
                }
            } catch {
                if (!cancelled) {
                    clearUser();
                    localStorage.removeItem('token');
                }
            } finally {
                if (!cancelled) {
                    setInitialized(true);
                }
            }
        };

        init();

        return () => {
            cancelled = true;
        };
    }, [initialized, user, setUser, clearUser, setInitialized]);
}
